import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MonitorPlay, Lock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useNextClass } from '../../lib/nextClass';
import { useNow } from '../../lib/useNow';
import { eventState, minutesLeft } from '../Calendar';

/** /group-classes: a red strip above the calendar while a class the student can see is running right now. */
export function LiveNowBanner({ onLocked }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const ev = useNextClass(user?.id);
  const now = useNow(30_000);
  if (!ev || eventState(ev, now) !== 'live') return null;
  const left = minutesLeft(ev, now);
  const join = () => {
    if (ev.is_locked) { onLocked?.(ev); return; }
    if (ev.in_app) navigate(`/live/class/${ev.id}`);
    else if (ev.zoom_link) window.open(/^[a-z][a-z0-9+.-]*:/i.test(ev.zoom_link) ? ev.zoom_link : `https://${ev.zoom_link}`, '_blank', 'noopener,noreferrer');
  };
  return (
    <div className="rounded-2xl bg-rose-600 text-white px-4 py-3 sm:px-5 flex items-center gap-3 sm:gap-4 flex-wrap shadow-lg shadow-rose-600/25 ring-2 ring-rose-300 ring-offset-2" data-testid="live-now-banner" data-event-id={ev.id}>
      <span className="inline-flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-wider shrink-0"><span className="w-2 h-2 rounded-full bg-white animate-pulse" /> Live now</span>
      <div className="flex-1 min-w-[160px]">
        <p className="font-bold text-sm sm:text-base leading-tight truncate" data-testid="live-now-title">{ev.title}</p>
        <p className="text-xs text-rose-100" data-testid="live-now-left">Started {new Date(ev.start_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })} · {left} min left{ev.attendee_count ? ` · ${ev.attendee_count} attending` : ''}</p>
      </div>
      <button type="button" onClick={join} className="inline-flex w-full sm:w-auto justify-center items-center gap-1.5 rounded-lg bg-white text-rose-700 font-bold text-sm px-4 py-2 hover:bg-rose-50 transition shadow" data-testid="live-now-join-btn" data-locked={ev.is_locked ? 'true' : 'false'}>
        {ev.is_locked ? <><Lock size={14} /> Upgrade to join</> : <><MonitorPlay size={14} /> Join now</>}
      </button>
    </div>
  );
}
